import React from 'react';
import { not } from 'ramda';
import { FormProvider } from 'react-hook-form';
import ButtonContainer from '@@viewCommonComponents/forms/ButtonContainer';
import useSimulationPricingsDailyBenefitForm from './hooks/useSimulationPricingsDailyBenefitForm';
import { ControlledRadioButton, ControlledSwitch } from '@@viewCommonComponents/controlled';
import { isRequiredSelect } from '@@viewHelpers/validations';
import {
  Icon,
  InfoMessage,
  PageSubtitle,
  PageTitle,
  QuoteTable
} from '@fasstech/middle-design-system';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import SimulationPricingsDailyBenefitExtraForm from './components/SimulationPricingsDailyBenefitExtraForm';
import { PageLayout } from '@@viewCommonComponents/forms/Layouts.jsx';

const SimulationPricingsDailyBenefitForm = ({
  getSimulationPricingsDailyBenefit,
  getMiddleText,
  getMiddleBoolean
}) => {
  const { form, onSubmit, isDutyOfAdviceSkipped, levels, annualPrice, monthlyPrice, isValid } =
    useSimulationPricingsDailyBenefitForm({
      getMiddleBoolean,
      getSimulationPricingsDailyBenefit,
      getMiddleText
    });

  const { processHandlers, context } = useProcess();

  const $onClickPrev = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId
      }
    });
  };

  return (
    <FormProvider {...form}>
      <form className={'w-full'} onSubmit={form.handleSubmit(onSubmit)}>
        <PageLayout>
          <Icon name={'circleHospital'} size={70} />
          <PageTitle>{getMiddleText('NIVEAUXGARANTIESETTARIFS_GENERAL_VIEW_TITLE')}</PageTitle>
          <PageSubtitle>
            {getMiddleText('NIVEAUXGARANTIESETTARIFS_GENERAL_VIEW_DESCRIPTION')}
          </PageSubtitle>
          <ControlledSwitch
            label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GARANTIES_GUARANTEE_LABEL')}
            form={form}
            name="collectionNeeds[0].isDutyOfAdviceSkipped"
            data-testid={'collectionNeedsIsDutyOfAdviceSkipped'}
          />

          {isDutyOfAdviceSkipped && (
            <>
              <InfoMessage iconName={'lightbulb'} className={'w-full'}>
                {getMiddleText('NIVEAUXGARANTIESETTARIFS_GARANTIES_GUARANTEE_SIDE_NOTE')}
              </InfoMessage>
              <SimulationPricingsDailyBenefitExtraForm form={form} />

              <ControlledRadioButton
                label={getMiddleText('NIVEAUXGARANTIESETTARIFS_GARANTIES_CHOIX_NIV_GAR_LABEL')}
                name={'pricing.level'}
                options={levels}
                form={form}
                rules={isRequiredSelect(levels, true)}
                data-testid={'NIVEAUXGARANTIESETTARIFS_CHOIX_NIV_GAR'}
                isResponsiveCol
                triggerOnChange
                className={`gap-4 grid-cols-1! md:!grid-cols-${levels.length}`}
                isDisplayed={getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GARANTIES_TARIF_EST_DEMANDE_NIVEAUX_GARANTIE_TARIF'
                )}
              />

              <QuoteTable
                title={'Montant total de cotisation'}
                iconName={'calculatorFilled'}
                rows={[
                  {
                    label: 'Montant cotisation',
                    monthlyAmount: monthlyPrice || '0',
                    annualAmount: annualPrice || '0'
                  }
                ]}
                isDisplayed={getMiddleBoolean(
                  'NIVEAUXGARANTIESETTARIFS_GARANTIES_TARIF_EST_DEMANDE_NIVEAUX_GARANTIE_TARIF'
                )}
                className={'border border-[#E7E7E7] rounded-lg p-4 w-full'}
              />
            </>
          )}
        </PageLayout>
        <ButtonContainer
          $onPreviousButtonClick={$onClickPrev}
          getMiddleText={getMiddleText}
          nextButtonLabel={getMiddleText('GENERAL_COMMON_TEXTS_NEXT_BUTTON_LABEL')}
          nextButtonIsDisabled={not(isValid)}
          displayResumeButton
        />
      </form>
    </FormProvider>
  );
};

export default SimulationPricingsDailyBenefitForm;
